import { useEffect, useState } from 'react';
import { GetGrUserFromAccessToken } from '../../connection/auth';

export interface UseProducerAccessResult {
	/** Null until the lookup lands, so "not loaded" is not read as "none". */
	channelIds: number[] | null;
	isProducer: boolean;
}

/**
 * The channels this user produces for, from the same profile route
 * `blAuthLoader` already calls. `gr_channels` on the session is the standalone
 * era's list and no longer maintained; this one is what the platform answers
 * with today.
 *
 * Fails closed: an error leaves no channels, and the gate refuses.
 */
export default function useProducerAccess(enabled: boolean): UseProducerAccessResult {
	const [result, setResult] = useState<UseProducerAccessResult>({
		channelIds: null,
		isProducer: false,
	});

	useEffect(() => {
		if (!enabled) return undefined;

		let cancelled = false;
		GetGrUserFromAccessToken().then((profile) => {
			if (cancelled) return;
			setResult({
				channelIds: profile?.channelIds ?? [],
				isProducer: !!profile?.isProducer,
			});
		});

		return () => { cancelled = true; };
	}, [enabled]);

	return result;
}
